export default __webpack_public_path__ + "static/media/ico-export.00a08989.svg";